/* McAdventures theme - stage 3: filters (events, stockists) and lesson tabs (learn). */
(function () {
  if (window.__mcPages) return;
  window.__mcPages = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Events: the page can be served from cache, so move any event whose last day has passed into Past events (before the filters bind).
    var up = document.querySelector('[data-ev-up]'), ps = document.getElementById('past-events');
    if (up && ps) {
      var list = ps.querySelector('.pg-evlist'), fl = ps.querySelector('.pg-filters'), now = new Date();
      up.querySelectorAll('li.ev[data-show-until]').forEach(function (el) {
        var d = el.getAttribute('data-show-until');
        if (!d || new Date(d + 'T23:59:59') >= now) return;
        var y = d.slice(0, 4);
        el.removeAttribute('data-banner'); el.removeAttribute('data-show-until'); el.setAttribute('data-key', y);
        var cta = el.querySelector('.ev-cta'); if (cta) cta.remove();
        var s = document.createElement('span'); s.className = 'ev-yr'; s.textContent = y;
        el.querySelector('.ev-date').appendChild(s);
        list.insertBefore(el, list.firstChild);
        ps.hidden = false;
        if (!fl.querySelector('[data-f="' + y + '"]')) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'fbtn'; b.setAttribute('data-f', y); b.setAttribute('aria-pressed', 'false'); b.textContent = y;
          fl.insertBefore(b, fl.children[1] || null);
        }
      });
      if (!up.querySelector('li.ev')) { var none = up.querySelector('[data-ev-none]'); if (none) none.hidden = false; }
    }

    // Filters: [data-pg-filter] holds buttons [data-f]; items are [data-pg-item][data-key] inside [data-pg-scope].
    document.querySelectorAll('[data-pg-filter]').forEach(function (group) {
      var scope = document.querySelector(group.getAttribute('data-pg-filter')) || document;
      var count = scope.querySelector('[data-pg-count]');
      var buttons = group.querySelectorAll('[data-f]');
      function apply(key) {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-f') === key ? 'true' : 'false'); });
        var n = 0;
        scope.querySelectorAll('[data-pg-item]').forEach(function (it) {
          var show = key === 'all' || it.getAttribute('data-key') === key;
          it.hidden = !show;
          if (show) n += parseInt(it.getAttribute('data-n') || '0', 10);
        });
        if (count) count.textContent = n + (n === 1 ? ' stockist' : ' stockists');
        var empty = scope.querySelector('[data-pg-empty]');
        if (empty) empty.hidden = scope.querySelectorAll('[data-pg-item]:not([hidden])').length > 0;
      }
      buttons.forEach(function (b) { b.addEventListener('click', function () { apply(b.getAttribute('data-f')); }); });
    });

    // Lesson tabs
    document.querySelectorAll('[data-pg-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      function show(i, focus) {
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', i === j ? 'true' : 'false');
          t.tabIndex = i === j ? 0 : -1;
        });
        panels.forEach(function (p, j) { p.hidden = i !== j; });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
      root.querySelectorAll('[data-next]').forEach(function (b) {
        b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-next'), 10)); });
      });
      show(0);
    });
  });
})();